import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { GenericCrudService } from './generic-crud.service';
const API_URL = environment.prismaApiUrl +'/api/dispo/base-good-categories';

@Injectable({
    providedIn: 'root'
})
export class BaseGoodCategoryService extends GenericCrudService<Product>{

    constructor(http: HttpClient) {
        super(http, 'api/dispo/base-good-categories');
    }
}

export interface Product {
    id: number;
    name: string;
    price: number;
    // Weitere Eigenschaften deines Produkts
}

